export enum ConnectionType {
  Zwift = 0,
  TrainingPeaks = 1,
  Strava = 2,
  Garmin = 3,
  Wahoo = 4,
  Facebook = 5,
  Apple = 6,
};

export type Connection = {
  id: number,
  type: ConnectionType,
  isWorkoutExportedEnabled: boolean,
};
